export default {
  SET_LIST(state, data) {
    state.history = data;
  },

  LAST_HISTORY(state, data) {
    state.lastHistory = data;
  },
};
